import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import {
  useSlotGroup,
  EditableSlotGroup,
  RichTextContent,
} from '@vibesites/runtime/react';
import { btnOnLight } from '../utils/buttonStyles';
import { ctaLinkProps } from '../utils/scheduleTourModal';

const ctaLinkDef: SlotGroupDefinition = {
  label: 'Interactive Map CTA',
  fields: {
    url: { label: 'URL', type: 'url', defaultValue: '/interactive-map' },
    label: { label: 'Label', type: 'text', defaultValue: 'INTERACTIVE MAP' },
    _target: { label: 'Link Target', type: 'text', defaultValue: '_self' },
  },
};

export function InteractiveMapCta() {
  const ctaLink = useSlotGroup('interactivemapcta.cta_link', ctaLinkDef);

  return (
    <section className="bg-background px-4 sm:px-6 py-12 md:py-16">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
        <EditableSlotGroup groupPath="interactivemapcta.cta_link" definition={ctaLinkDef}>
          <a
            {...ctaLinkProps(ctaLink.url || '/interactive-map', ctaLink._target)}
            className={`inline-flex items-center justify-center px-10 py-4 font-body text-sm font-medium tracking-[0.2em] uppercase ${btnOnLight}`}
          >
            {ctaLink.label || 'INTERACTIVE MAP'}
          </a>
        </EditableSlotGroup>

        <RichTextContent
          path="interactivemapcta.disclaimer"
          as="p"
          className="mt-8 max-w-2xl font-body text-xs sm:text-sm leading-relaxed text-muted-foreground"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapCta',
  displayName: 'Interactive Map CTA',
  tokens: {
    'interactivemapcta.disclaimer': {
      label: 'Disclaimer',
      type: 'richtext',
      defaultValue:
        '<p>*Total monthly leasing prices include base rent and all mandatory monthly fees. Excludes user-selected optional fees, variable or usage-based fees and required charges due at or prior to move-in or at move-out.</p>',
    },
  },
  slotGroups: {
    'interactivemapcta.cta_link': ctaLinkDef,
  },
};

(InteractiveMapCta as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default InteractiveMapCta;
